// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichTextEditor__wrapper___1DiEG","editor":"RichTextEditor__editor___ZjPXD","toolbar":"RichTextEditor__toolbar___2z3lc"};